<link href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.0/css/bootstrap.min.css" rel="stylesheet" id="bootstrap-css">
<script src="//maxcdn.bootstrapcdn.com/bootstrap/3.3.0/js/bootstrap.min.js"></script>
<script src="//code.jquery.com/jquery-1.11.1.min.js"></script>
<nav class="navbar navbar-expand-lg navbar-light bg-light d-flex justify-content-xl-between align-items-center  shop_id_{{shopId}}">
  <a class="navbar-brand" routerLink="home" (click)="getPage('Home')" style="width:270px">
    <img *ngIf="shopId=='1'" src="assets/john-steel-logo.jpg">
    <img *ngIf="shopId=='2'" src="assets/logo-js-biz.png">
  </a>
  <a class="nav-link">
    <span class="navbar-text nav-item" [hidden]='!isAuth && !admin'>
      <mat-form-field appearance="fill" *ngIf='page == "Service"'>
        <mat-label>Service</mat-label>
        <mat-select (selectionChange)="test($event)" [(value)]="userService">
          <mat-option *ngFor="let service of services" [value]="service">
            {{service}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>
  </a>
  <a class="nav-link">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup"
      aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
      <ul class="nav navbar-nav ml-auto justify-content-center">
        <li class="nav-item">
          <a class="nav-link" routerLink="auth/signin" *ngIf="!isAuth">Connexion</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="auth/signup" *ngIf="!isAuth">Créer un compte</a>
        </li>
        <span class="navbar-text">
          <mat-button-toggle-group name="fontStyle" aria-label="Font Style" *ngIf='isAuth' value="manuel">
            <mat-button-toggle value="manuel" (click)="showDate()" mat-button [matMenuTriggerFor]="menu">Du
              {{date_start}}
              au {{date_end}}</mat-button-toggle>
            <mat-button-toggle value="real" (click)="setRealTime()">Temps Réel</mat-button-toggle>
          </mat-button-toggle-group>
        </span>
      </ul>
    </div>
  </a>
<mat-slide-toggle (change)="switchIdShop()">
  JSBIZ
</mat-slide-toggle>
</nav>
<mat-menu #menu="matMenu">
  <div fxLayout="row">
    <div fxLayout="column">
      <button (click)="selectDate('week')" mat-menu-item>Dernière semaine</button>
      <button (click)="selectDate('month')" mat-menu-item>Dernier mois</button>
      <button (click)="selectDate('year')" mat-menu-item>Dernière année</button>
      <button [matMenuTriggerFor]="dateTimeMenu" mat-menu-item>Custom</button>
    </div>
    <mat-menu class="date-range-menu" #dateTimeMenu="matMenu">
      <form (submit)="onSubmit()">
        <div fxLayout="row" (click)="$event.stopPropagation();">
          <mat-label>Du </mat-label>
          <input matInput [matDatepicker]="datestart" [value]="date_start" [(ngModel)]="start" name="start">
          <mat-datepicker #datestart></mat-datepicker>
          <button type="button" class="btn btn-outline-secondary btn-sm" (click)="datestart.open()">
            <i class="fa fa-calendar" aria-hidden="true" mat-raised-button></i>
          </button>
        </div>
        <div fxLayout="row" (click)="$event.stopPropagation();">
          <mat-label>au </mat-label>
          <input matInput [matDatepicker]="dateend" [value]="date_end" [(ngModel)]="end" name="end">
          <mat-datepicker #dateend></mat-datepicker>
          <button type="button" class="btn btn-outline-secondary btn-sm" (click)="dateend.open()">
            <i class="fa fa-calendar" aria-hidden="true" mat-raised-button (click)="dateend.open()"></i>
          </button>
        </div>
        <button type="submit" class="btn btn-success btn-sm"><i class="fa fa-check" aria-hidden="true"></i></button>
      </form>
    </mat-menu>
  </div>
</mat-menu>
<!-- <nav class="navbar navbar-expand-lg navbar-light bg-light vertical-nav" (mouseenter)="sidebar(true)" (mouseout)="sidebar(false)" [style.right.rem]="right">
  <ul class="navbar-nav flex-column" (mouseenter)="sidebar(true)">
    <li class="nav-item" (mouseenter)="sidebar(true)">
      <a class="nav-link" *ngIf='isAuth' routerLink="home" (click)="getPage('Home')" (mouseenter)="sidebar(true)">Vue globale <span
          class="sr-only" (mouseenter)="sidebar(true)">(current)</span></a>
    </li>
    <li class="nav-item" (mouseenter)="sidebar(true)">
      <a class="nav-link" *ngIf='isAuth && userService != "Autre"' routerLink="user/service"
        (click)="getPage('Service')" (mouseenter)="sidebar(true)">Vue service</a>
    </li>
    <li class="nav-item" (mouseenter)="sidebar(true)">
      <a class="nav-link" *ngIf='isAuth' routerLink="user/profil" (click)="getPage('Perso')">Vue perso</a>
    </li>
    <li class="nav-item" (mouseenter)="sidebar(true)">
      <a class="nav-link" *ngIf='isAuth && admin' routerLink="user/admin" (click)="getPage('Admin')">Admin</a>
    </li>
    <li class="nav-item">
      <i class="fa fa-cogs" aria-hidden="true"></i>
    </li>
  </ul>
</nav> -->
<!-- 
<div class="col-sm-4" style="position: fixed; right: -38rem; z-index: 1;">
  <div class="col-xs-3">
    <ul class="nav nav-tabs tabs-left bg-light">
      <li [ngClass]="page === 'Home' ? 'active' : ''"><a class="nav-link" *ngIf='isAuth' routerLink="home" (click)="getPage('Home')"
          (mouseenter)="sidebar(true)">Vue globale</a></li>
      <li [ngClass]="page === 'Service' ? 'active' : ''"><a class="nav-link" *ngIf='isAuth && userService != "Autre"' routerLink="user/service"
          (click)="getPage('Service')">Vue service</a></li>

      <li [ngClass]="page === 'Perso' ? 'active' : ''"><a class="nav-link" *ngIf='isAuth' routerLink="user/profil" (click)="getPage('Perso')">Vue perso</a></li>
      <li [ngClass]="page === 'Admin' ? 'active' : ''"><a class="nav-link" *ngIf='isAuth && admin' routerLink="user/admin" (click)="getPage('Admin')">Admin</a></li>
    </ul>
  </div>
</div> -->
<!-- 
<div class="col-sm-4" style="position: fixed; right: -38rem; z-index: 1;">
  <div class="col-xs-3">
    <ul class="nav nav-tabs tabs-left bg-light">
      <li [ngClass]="page === 'Home' ? 'active' : ''"><a class="nav-link" *ngIf='isAuth' routerLink="user/admin"(click)="sidebar(true)">Test</a></li>
      <li [ngClass]="page === 'Service' ? 'active' : ''"><a class="nav-link" *ngIf='isAuth' routerLink="user/admin"(click)="sidebar(true)">Test</a></li>

      <li [ngClass]="page === 'Perso' ? 'active' : ''"><a class="nav-link" *ngIf='isAuth' routerLink="user/admin"(click)="sidebar(true)">Test</a></li>
      <li [ngClass]="page === 'Admin' ? 'active' : ''"><a class="nav-link" *ngIf='isAuth' routerLink="user/admin"(click)="sidebar(true)">Test</a></li>
    </ul>
  </div>
</div>
<nav class="navbar navbar-expand-lg navbar-light bg-light vertical-nav" (mouseenter)="sidebar(true)" (mouseout)="sidebar(false)" [style.right.rem]="right">
  <ul class="navbar-nav flex-column" (mouseenter)="sidebar(true)">
    <li class="nav-item" (mouseenter)="sidebar(true)">
      <a class="nav-link" *ngIf='isAuth' routerLink="home" (click)="getPage('Home')" (mouseenter)="sidebar(true)">Vue globale <span
          class="sr-only" (mouseenter)="sidebar(true)">(current)</span></a>
    </li>
    <li class="nav-item" (mouseenter)="sidebar(true)">
      <a class="nav-link" *ngIf='isAuth && userService != "Autre"' routerLink="user/service"
        (click)="getPage('Service')" (mouseenter)="sidebar(true)">Vue service</a>
    </li>
    <li class="nav-item" (mouseenter)="sidebar(true)">
      <a class="nav-link" *ngIf='isAuth' routerLink="user/profil" (click)="getPage('Perso')">Vue perso</a>
    </li>
    <li class="nav-item" (mouseenter)="sidebar(true)">
      <a class="nav-link" *ngIf='isAuth && admin' routerLink="user/admin" (click)="getPage('Admin')">Admin</a>
    </li>
    <li class="nav-item">
      <i class="fa fa-cogs" aria-hidden="true"></i>
    </li>
  </ul>
</nav> -->


<div class="sidebar" style="position: fixed; z-index: 1;" [style.right.px]="right" *ngIf="isAuth">
  <div>
    <!-- required for floating -->
    <!-- Nav tabs -->
    <ul class="nav nav-tabs tabs-left d-flex flex-column">
      <li [ngClass]="view === 'view' ? 'active' : ''"><a data-toggle="tab" (click)="sidebar(true, 'view')"><i
            class="fa fa-eye" aria-hidden="true"></i></a></li>
      <li [ngClass]="view === 'graph' ? 'active' : ''" *ngIf="page!='Admin' && admin || page=='Perso'"><a
          data-toggle="tab" (click)="sidebar(true, 'graph')"><i class="fa fa-bar-chart" aria-hidden="true"></i></a></li>
      <li><a data-toggle="tab" (click)="sidebar(true, 'option')"><i class="fa fa-cog" aria-hidden="true"></i></a></li>
      <li *ngIf="view!=''"><a data-toggle="tab" (click)="sidebar(false,'')"><i class="fa fa-times"
            aria-hidden="true"></i></a></li>
    </ul>
  </div>
  <div class="col-xs-3" style="position: fixed; top: 80px;">
    <ul class="navbar-nav flex-column contenu" [style.right.px]="rightView">
      <li class="nav-item">
        <a class="nav-link" *ngIf='isAuth' routerLink="home" (click)="getPage('Home')">Vue globale</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" *ngIf='isAuth && userService != "Autre"' routerLink="user/service"
          (click)="getPage('Service')">Vue service</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" *ngIf='isAuth' routerLink="user/profil" (click)="getPage('Perso')">Vue perso</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" *ngIf='isAuth && admin' routerLink="user/admin" (click)="getPage('Admin')">Admin</a>
      </li>
    </ul>
    <ul class="navbar-nav flex-column  contenu" [style.right.px]="rightOption">
      <li class="nav-item">
        <a class="nav-link" (click)="onSignOut()" *ngIf='isAuth' style="cursor: pointer;">Déconnexion</a>
      </li>
    </ul>
  </div>
</div>